import { FONT_WEIGHT } from '@bugbug/core/theme/fonts';
import styled from 'styled-components';

export const Sup = styled.sup`
  font-weight: ${FONT_WEIGHT.MEDIUM};
`;
